import { Component, input } from '@angular/core';

@Component({
	selector: 'crust-logo',
	templateUrl: './crust-logo.html',
	standalone: true
})
export class CrustLogoComponent {
	color = input<string>('#496576');
	size = input<string>('h-8 w-auto');
}
